module.exports = __webpack_public_path__ + "img/icon_aside_ppt1_active.d1e27b88.svg";